const DOW = ['일', '월', '화', '수', '목', '금', '토'];
const pad2 = (n: number) => String(n).padStart(2, '0');

/**
 * LocalDateTime("2026-10-02T13:50:23" / 소수초 포함) 또는 LocalDate("2026-10-02") → Date.
 * 서버가 타임존 없이 서울 시각을 내려주므로 브라우저 로컬 시각으로 그대로 읽는다.
 */
export function parseDtm(iso: string): Date {
  const trimmed = iso.length > 19 ? iso.slice(0, 19) : iso;
  return new Date(trimmed.length === 10 ? `${trimmed}T00:00:00` : trimmed);
}

/** 2026.06.11 (수) */
export function fmtDateDow(iso: string): string {
  const d = parseDtm(iso);
  return `${d.getFullYear()}.${pad2(d.getMonth() + 1)}.${pad2(d.getDate())} (${DOW[d.getDay()]})`;
}

/** 2026.06.08 (월) 21:10 */
export function fmtDateDowTime(iso: string): string {
  const d = parseDtm(iso);
  return `${fmtDateDow(iso)} ${pad2(d.getHours())}:${pad2(d.getMinutes())}`;
}

/** 6월 8일 */
export function fmtMonthDayKo(iso: string): string {
  const d = parseDtm(iso);
  return `${d.getMonth() + 1}월 ${d.getDate()}일`;
}

/** 06.11 18:40 */
export function fmtMdTime(iso: string): string {
  const d = parseDtm(iso);
  return `${pad2(d.getMonth() + 1)}.${pad2(d.getDate())} ${pad2(d.getHours())}:${pad2(d.getMinutes())}`;
}

/** 2026.05.28 */
export function fmtDate(iso: string): string {
  const d = parseDtm(iso);
  return `${d.getFullYear()}.${pad2(d.getMonth() + 1)}.${pad2(d.getDate())}`;
}

/** 07.15 (같은 해 범위의 끝 날짜 표기용) */
export function fmtMd(iso: string): string {
  const d = parseDtm(iso);
  return `${pad2(d.getMonth() + 1)}.${pad2(d.getDate())}`;
}

/** 날짜 그룹 키 — YYYY-MM-DD */
export function dateKey(iso: string): string {
  const d = parseDtm(iso);
  return `${d.getFullYear()}-${pad2(d.getMonth() + 1)}-${pad2(d.getDate())}`;
}

/** 두 날짜 사이 일수(a→b). 시각은 무시한다. */
export function diffDays(a: Date, b: Date): number {
  const ua = Date.UTC(a.getFullYear(), a.getMonth(), a.getDate());
  const ub = Date.UTC(b.getFullYear(), b.getMonth(), b.getDate());
  return Math.round((ub - ua) / 86400000);
}

export const DOW_KO = DOW;

/** 탭 배지 숫자 — 0이면 호출부가 숨기고, 100 이상은 "99+" (화면기획서 탭 배지 규칙). */
export function badgeText(count: number): string {
  return count >= 100 ? '99+' : String(count);
}
